import React from 'react';
import { Typography } from '@mui/material';
import Layout from '../components/Layout/Layout';

const Settings: React.FC = () => {
  return (
    <Layout>
      <Typography variant="h4">Settings</Typography>
      {/* TODO: Implement settings view */}
    </Layout>
  );
};

export default Settings;